import { type ReactNode } from 'react';
import { Trophy, Medal, Award } from 'lucide-react';

function getRankIcon(pos: number): ReactNode {
  if (pos === 1) return <Trophy size={16} className="text-warning" />;
  if (pos === 2) return <Medal size={16} className="text-text-secondary" />;
  if (pos === 3) return <Award size={16} className="text-brand-coral" />;
  return null;
}

export function RankingCard({
  position,
  total,
}: {
  position: number;
  total: number;
}): ReactNode {
  return (
    <div className="rounded-xl bg-white/[0.02] p-base">
      <p className="text-[11px] font-medium uppercase tracking-wider text-text-tertiary/60">
        Ranking
      </p>
      <div className="mt-xs flex items-baseline gap-xs">
        {getRankIcon(position)}
        <span className="font-mono text-2xl font-bold tabular-nums text-text-primary">
          #{position}
        </span>
        <span className="font-mono text-[11px] tabular-nums text-text-tertiary/40">
          /{total}
        </span>
      </div>
    </div>
  );
}
